export default __webpack_public_path__ + "static/media/jventures.ee0fe26b.png";